import type { ContentKeyDef } from "@/content/landing";
import { FUNNEL_COPY } from "@/content/funnel-copy";

export const S2B_SECTION = "screen.s2b";

export const S2B_CONTENT: ContentKeyDef[] = [
  { key: "s2b.header.backLabel", label: "Back link", group: "Header", default: FUNNEL_COPY["s2b.header.backLabel"] },
  { key: "s2b.header.step", label: "Step indicator", group: "Header", default: FUNNEL_COPY["s2b.header.step"] },
  { key: "s2b.style.label", label: "Style card — small label", group: "Header", default: FUNNEL_COPY["s2b.style.label"] },
  { key: "s2b.style.fallbackName", label: "Style card — fallback name", group: "Header", default: FUNNEL_COPY["s2b.style.fallbackName"] },
  { key: "s2b.header.title", label: "Title", group: "Header", default: FUNNEL_COPY["s2b.header.title"] },
  { key: "s2b.header.subtitle", label: "Subtitle", group: "Header", default: FUNNEL_COPY["s2b.header.subtitle"], multiline: true },
  { key: "s2b.reuse.title", label: "Reuse option — title", group: "Actions", default: FUNNEL_COPY["s2b.reuse.title"] },
  { key: "s2b.reuse.body", label: "Reuse option — body", group: "Actions", default: FUNNEL_COPY["s2b.reuse.body"], multiline: true },
  { key: "s2b.retake.title", label: "Retake option — title", group: "Actions", default: FUNNEL_COPY["s2b.retake.title"] },
  { key: "s2b.retake.body", label: "Retake option — body", group: "Actions", default: FUNNEL_COPY["s2b.retake.body"], multiline: true },
  { key: "s2b.legal.link", label: "Policy link", group: "Legal", counsel: true, default: FUNNEL_COPY["s2b.legal.link"] },
  { key: "s2b.legal.body", label: "Privacy notice", group: "Legal", counsel: true, default: FUNNEL_COPY["s2b.legal.body"], multiline: true, orphan: "never placed — S2bSameFace renders its own reviewed wording; this key reaches no customer. Decide whether to show it before approving wording." },
];

export const S2B_DEFAULTS: Record<string, string> = Object.fromEntries(
  S2B_CONTENT.map((k) => [k.key, k.default])
);
